"use client";

import { useCallback, useEffect } from "react";
import { useAppSettings } from "@/shared";
import {
  AdminTopMenu,
  AdminHeader,
  AdminSidebar,
  AdminSidebarRight,
} from "@/widgets";

export function AdminDefaultLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { settings } = useAppSettings();

  const handleScroll = useCallback(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const totalScroll = window.scrollY;
      const elm = document.querySelector(".app");

      if (elm) {
        if (totalScroll > 0) {
          elm.classList.add("has-scroll");
        } else {
          elm.classList.remove("has-scroll");
        }
      }
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <div
      className={
        "app " +
        (settings.appClass ? settings.appClass + " " : "") +
        (settings.appBoxedLayout ? "app-boxed-layout " : "") +
        (settings.appContentFullHeight ? "app-content-full-height " : "") +
        (settings.appHeaderNone ? "app-without-header " : "") +
        (settings.appHeaderFixed && !settings.appHeaderNone
          ? "app-header-fixed "
          : "") +
        (settings.appSidebarWide ? "app-with-wide-sidebar " : "") +
        (settings.appSidebarTwo ? "app-with-two-sidebar " : "") +
        (settings.appSidebarEnd ? "app-with-end-sidebar " : "") +
        (settings.appSidebarHover ? "app-with-hover-sidebar " : "") +
        (settings.appSidebarEndToggled ? "app-sidebar-end-toggled " : "") +
        (settings.appSidebarEndMobileToggled
          ? "app-sidebar-end-mobile-toggled "
          : "") +
        (settings.appSidebarNone ? "app-without-sidebar " : "") +
        (settings.appSidebarFixed ? "app-sidebar-fixed " : "") +
        (settings.appSidebarMinified ? "app-sidebar-minified " : "") +
        (settings.appSidebarMobileToggled ? "app-sidebar-mobile-toggled" : "") +
        (settings.appFooter ? "app-footer-fixed " : "") +
        (settings.appTopMenu ? "app-with-top-menu " : "") +
        (settings.appGradientEnabled ? "app-gradient-enabled " : "")
      }
    >
      {settings.appTopMenu && <AdminTopMenu />}
      {!settings.appHeaderNone && <AdminHeader />}
      {!settings.appSidebarNone && <AdminSidebar />}
      {!settings.appContentNone && (
        <div className={"app-content " + settings.appContentClass}>
          {children}
        </div>
      )}
      {settings.appSidebarTwo && <AdminSidebarRight />}
      {settings.appContentNone && <>{children}</>}
      {/* <ThemePanel /> */}
    </div>
  );
}
